
import { defineComponent } from "vue";
import IconButton from "@/components/IconButton.vue";

export default defineComponent({
  name: "ChatSendButton",

  inheritAttrs: false,

  components: {
    IconButton
  }
});
